import { useEffect } from 'react';

const useTitleOnMount = (title: string) => {
  useEffect(() => {
    window.parent.document.title = `${title} | Qantas Hotels`;
  }, [title]);
};

export default useTitleOnMount;
